import React, { useEffect, useState } from "react";
import { MdOutlineArrowBack } from "react-icons/md";
import Select from "react-select";
import { contactUsApi } from "../utils/api";
// import { useJitsu } from "@jitsu/react";

function ContactForm({ setOpenForm, queryReasons, settings }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [reason, setReason] = useState("");
  const [reasonOptions, setReasonOptions] = useState([]);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  // const { track } = useJitsu();
  const contactApi = () => {
    setLoading(true);
    contactUsApi(settings.merchant.id, name, email, phone, reason, message)
      .then((resp) => {
        if (resp.data.success) {
          setName("");
          setPhone("");
          setEmail("");
          setMessage("");
          setReason("");
          setSuccess(true);
        }
      })
      .catch((err) => {
        // To do
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    var tempReasons = [];
    for (let i = 0; i < queryReasons.length; i++) {
      tempReasons.push({
        value: queryReasons[i],
        label: queryReasons[i],
      });
    }
    setReasonOptions(tempReasons);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {/* Header  */}
      <div
        className="flex items-center px-4 py-2.5 cursor-pointer h-16 text-white"
        style={{
          boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.12)",
          background: settings["--site-widget-primary-color"],
        }}
        onClick={() => setOpenForm(false)}
      >
        <MdOutlineArrowBack />
        <p className="ml-2 fw-medium text-sm">Back</p>
        <div
          className="max-w-[120px] absolute"
          style={{ transform: "translateX(-50%)", left: "50%" }}
        >
          <img
            src={settings.logo_url}
            className="w-auto text-center ml-5 max-h-12"
            alt={settings.merchant.storename}
          />
        </div>
      </div>

      {success ? (
        <div className="text-center h-screen flex flex-col justify-center items-center px-5 text-sm -mt-20">
          <p>
            Thank you for contacting us. <br /> Your email has been sent
            successfully. 👍
          </p>
          <p className="mt-3">
            🕒 Please allow us some time to review your message, and we will get
            back to you as soon as possible.
          </p>
        </div>
      ) : (
        <div>
          <p
            className="text-xs font-medium px-5 mt-6 mb-2"
            style={{ color: "#151F32" }}
          >
            Send us a message and we will reach out to you ASAP
          </p>
          <form
            className="px-5"
            onSubmit={(e) => {
              e.preventDefault();
              // track("leave_message_form_submitted");
              contactApi();
            }}
          >
            <input
              type="text"
              className="w-full rounded-xl border mt-3 p-3 text-sm"
              placeholder="Full name"
              required
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="text"
              className="w-full rounded-xl border mt-3 p-3 text-sm"
              placeholder="Phone"
              required
              onChange={(e) => setPhone(e.target.value)}
            />
            <input
              type="email"
              className="w-full rounded-xl border mt-3 p-3 text-sm"
              placeholder="Email"
              required
              onChange={(e) => setEmail(e.target.value)}
            />
            {reasonOptions.length > 0 && (
              <Select
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    borderRadius: "10px",
                  fontSize: "12px",
                  padding: "4px 0",
                  color: "#9B9FA7",
                  }),
                }}
                required
                onChange={(e) => setReason(e.value)}
                placeholder="Choose your reason"
                className="mt-3"
                options={reasonOptions}
              />
            )}
            <textarea
              className="w-full rounded-xl border mt-3 p-3 text-sm"
              placeholder="Message"
              onChange={(e) => setMessage(e.target.value)}
            />
            <button
              className="w-full rounded-xl mt-4 text-white p-4 text-sm font-medium"
              style={{ background: settings["--site-widget-primary-color"] }}
              type="submit"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default ContactForm;
